import { isLoggedIn } from "utils";
import { History } from "history";

export const handleRouteRedirect = ({
  settingInformationData,
  history,
}: {
  settingInformationData: any;
  history: History;
}) => {
  const currentPathName = window.location.pathname;

  const commonURL = [
    "/personalregistration/SII",
    "/verify-phone-number",
    "/account-registration",
    "/verify-otp",
    "/download-app-qr",
  ];
  const publicURL = [
    "/login",
    "/forgot-password",
    "/forgot-password-notification",
    "/reset-password",
    "/reset-password-notification",
    "/expire-reset-link-notification",
    ...commonURL,
  ];

  const privateURL = [
    "/education-consultation-list",
    "/settings",
    "/dashboard",
    "/message-delivery",
    "/resources-download",
    "/change-password",
    "/message-delivery/history",
    ...commonURL,
  ];
  const restrictedUrl: any[] = [];

  if (settingInformationData?.result) {
    if (!settingInformationData?.result?.is_able_consultation_nav) {
      restrictedUrl.push("/education-consultation-list");
    }
  }

  if (isLoggedIn()) {
    if (!privateURL.includes(currentPathName) || currentPathName === "/") {
      history.replace("/user-list");
    }
    if (restrictedUrl.length && restrictedUrl.includes(currentPathName)) {
      history.replace("/user-list");
    }
  } else {
    if (!publicURL.includes(currentPathName) || currentPathName === "/") {
      history.replace("/login");
    }
  }
};
